var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtChild',{attrs:{"product":_vm.product,"initial-comments":_vm.initialComments}})
}
var staticRenderFns = []

export { render, staticRenderFns }